export default "__VITE_ASSET__DAq21Zq2__"